import { Check } from 'lucide-react'

import { cn } from '@fortem-monorepo/js-utilities'
import { getAcronymFromString } from '@fortem-monorepo/js-utilities'
import { useUserContext } from '@fortem-monorepo/react-spa'
import { Avatar, AvatarFallback, AvatarImage } from '@fortem-monorepo/react-ui'
import { Badge } from '@fortem-monorepo/react-ui'
import { Button } from '@fortem-monorepo/react-ui'
import { Card, CardDescription, CardHeader, CardTitle } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { testUsers } from '@/constants/test-users'

export interface ImpersonationModalProps {}

export const ImpersonationModal: React.FC<ImpersonationModalProps> = ({}) => {
  const {
    showImpersonationModal,
    setShowImpersonationModal,
    impersonate,
    impersonatingUser,
    isImpersonating,
    stopImpersonating,
    loggedInUser,
  } = useUserContext()

  return (
    <Dialog
      open={showImpersonationModal}
      onOpenChange={(open) => {
        if (!open) {
          setShowImpersonationModal(false)
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Impersonate a User</DialogTitle>
          <div>You are currently logged in as: {loggedInUser.user?.name}</div>
          <div className={'flex flex-col gap-2'}>
            You have the following roles:{' '}
            <div className={'flex gap-2'}>
              {loggedInUser.roles.map((role) => (
                <Badge className={'inline-flex'} key={role}>
                  {role}
                </Badge>
              ))}
            </div>
          </div>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          {testUsers.map((user) => {
            const isActive = impersonatingUser?.user?.name === user.user?.name

            return (
              <Card
                className={cn('relative hover:bg-sidebar-accent transition-colors cursor-pointer', {
                  ['pointer-events-none outline-1 outline-green-400']: isActive,
                })}
                onClick={() => {
                  impersonate(user)
                  setShowImpersonationModal(false)
                }}
                key={user.user?.email}
              >
                <CardHeader>
                  <div className={'flex gap-2'}>
                    <Avatar className="h-8 w-8 rounded-lg">
                      <AvatarImage src={user.user?.picture} alt={user.user?.name} />
                      <AvatarFallback className="rounded-lg">
                        {getAcronymFromString(user.user?.name)}
                      </AvatarFallback>
                    </Avatar>
                    <div>
                      <CardTitle>{user.user?.name}</CardTitle>
                      <CardDescription>{user.user?.email}</CardDescription>
                    </div>
                  </div>
                  {isActive && (
                    <div className={'flex items-center gap-2 text-muted-foreground text-xs mt-2'}>
                      <Check size={18} className={'text-green-600'} />
                      Currently selected
                    </div>
                  )}
                  <div className={'absolute top-4 right-6'}>
                    {user.roles.map((role) => {
                      return (
                        <Badge
                          variant={'outline'}
                          className={cn({
                            ['opacity-50']: isActive,
                          })}
                          key={role}
                        >
                          {role}
                        </Badge>
                      )
                    })}
                  </div>
                </CardHeader>
              </Card>
            )
          })}
        </div>
        <DialogFooter>
          <Button
            disabled={!isImpersonating}
            onClick={() => {
              stopImpersonating()
              setShowImpersonationModal(false)
            }}
            variant={'destructive'}
          >
            Stop Impersonating
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
